module.exports = __webpack_public_path__ + "static/img/5g2.90ad97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5g2.png
// module id = Mx7z
// module chunks = 21